import { WebClientDetailFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientDetailFetcher';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { LensMapper } from '../mappers/LensMapper';
import { ILensDetailInfo, ILensInfo } from '../models/ILensInfo';
import { DeleteLensesRequest } from '../ServerApi/requests/DeleteLensesRequest';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { GetLensActionsRequest } from '../ServerApi/requests/GetLensActionsRequest';
import { GetLensesRequest } from '../ServerApi/requests/GetLensesRequest';
import { MoveLensesToProjectRequest } from '../ServerApi/requests/MoveLensesToProjectRequest';
import { SetLensesOwnerRequest } from '../ServerApi/requests/SetLensesOwnerRequest';
import { ILensActions } from '../ServerApi/types/ILensAction';
import { FieldValuesQuery } from './FieldValuesQuery';
import { IActionResource, IDetailResource, IFieldValuesResource, IListResource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class LensesResource implements IListResource<ILensInfo>, IFieldValuesResource, IDetailResource<ILensDetailInfo>, IActionResource<ILensActions> {

  private listFetcher = new WebClientListResourceFetcher(GetLensesRequest, ServerApiMapper.lenses);
  private detailFetcher = new WebClientDetailFetcher('getLens', LensMapper.mapDetail);
  private fieldValuesFetcher = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<ILensInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string): Promise<ILensDetailInfo> {
    return this.detailFetcher.fetchById(id);
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'lens');
  }

  // Actions
  public actions(id: string): Promise<ILensActions> {
    return WebHttpClient.sendRequest(new GetLensActionsRequest(id));
  }

  public deleteLenses(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteLensesRequest(idsBlock)),
      ResultHelper.combineResults
    );
  }

  public setOwner(ids: string[], ownerId: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetLensesOwnerRequest(idsBlock, ownerId)),
      ResultHelper.combineResults);
  }

  public moveToProject(targetProjectId: string, lensIds: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(lensIds, (idsBlock) => new MoveLensesToProjectRequest({
        ids: idsBlock,
        projectId: targetProjectId
      })),
      ResultHelper.combineResults);
  }
}

export const Lenses = new LensesResource();
